'use strict';
var $ = require('../internals/export');
var call = require('../internals/function-call');

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$({ target: 'URL', proto: true, enumerable: true }, {
  toJSON: function toJSON() {
    return call(URL.prototype.toString, this);
  }
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/web.url.to-json.js
// module id = 1552
// module chunks = 0